/*
  Blocks submission of any form whose honeypot field has been filled.

  Capture phase and stopImmediatePropagation, so it runs before any other submit
  handler on the page rather than racing them.

  Scope, stated plainly: Shopify's form tags post straight to Shopify, so there
  is no server of ours in the path and nothing can be rejected server-side. This
  catches bots that execute JS. A bot that POSTs directly is unaffected — see
  snippets/ctl-honeypot.liquid.
*/
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const trap = form.querySelector('[data-ctl-honeypot]');
    if (trap && trap.value !== '') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);
